/** Mirrors server perm_grant__{building_id} convention (client-safe, no server import). */
export const PERM_QUESTION_PREFIX = "perm_grant__";

export function isPermQuestionId(questionId: string): boolean {
  return questionId.startsWith(PERM_QUESTION_PREFIX);
}
